// src/components/FlightList.js
import React from "react";
import PropTypes from "prop-types";
import { Card, Row, Col } from "react-bootstrap";
import { AIRPORTS } from "../airportData";

function FlightList({ flights }) {
  if (!flights.length) {
    return <p className="text-center">Keine Ergebnisse gefunden.</p>;
  }

  return (
    <Row>
      {flights.map((f, i) => (
        <Col md={4} sm={6} xs={12} key={i} className="mb-4">
          <Card className="h-100">
            <Card.Body>
              <Card.Title>
                {AIRPORTS[f.from] || f.from} → {AIRPORTS[f.to] || f.to}
              </Card.Title>

              {/* Flug-Infos */}
              <Card.Text>
                <strong>Preis:</strong> {f.price} €<br />
                <strong>Hinflug:</strong> {f.depart}<br />
                <strong>Rückflug:</strong> {f.return}
              </Card.Text>

              {/* Hotel-Info */}
              {f.hotel && (
                <Card.Text className="mt-3">
                  <hr />
                  <strong>Hotel:</strong><br />
                  {f.hotel.name} – {f.hotel.price} € 
                  {f.hotel.stars && ` – ${f.hotel.stars}★`}
                  {f.hotel.link && (
                    <>
                      <br />
                      <a
                        href={f.hotel.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-link btn-sm mt-2"
                      >
                        Hotel ansehen
                      </a>
                    </>
                  )}
                </Card.Text>
              )}

              <div className="d-flex justify-content-between mt-3">
                <a
                  href={f.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Flug ansehen
                </a>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

FlightList.propTypes = {
  flights: PropTypes.arrayOf(
    PropTypes.shape({
      from: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      depart: PropTypes.string.isRequired,
      return: PropTypes.string.isRequired,
      link: PropTypes.string,
      airline: PropTypes.string,
      hotel: PropTypes.shape({
        name: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        stars: PropTypes.number,
        link: PropTypes.string
      })
    })
  ).isRequired
};

export default FlightList;
